import styled from '@emotion/styled';
import { fontSizes } from '__app/typography';
import KizenInlineStepper from '__components/Kizen/Stepper';

type PerformActionStepperProps = {
  currentStep: number;
  steps: { title: string }[];
};

const StepBlock = styled.div`
  position: relative;
  height: 75px;
  width: 100%;
  margin-top: -10px;
`;

const StepWrapper = styled.div`
  width: 100%;
  position: absolute;

  // overwrite for react-stepper-horizontal-with-classes
  .stepper-circle-completed {
    font-size: ${fontSizes.micro};
  }

  .stepper-title-completed,
  .stepper-title-unstarted {
    line-height: 125%;
  }
`;

export const PerformActionStepper = ({
  currentStep,
  steps = [],
}: PerformActionStepperProps) => {
  return (
    <StepBlock>
      <StepWrapper>
        <KizenInlineStepper
          steps={steps}
          activeStep={currentStep - 1}
          circleTop={11}
        />
      </StepWrapper>
    </StepBlock>
  );
};
